"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const DispatchContext_1 = require("../../context/DispatchContext");
const Context_1 = require("../../elements/popup/Alert/Context");
const Context_2 = require("../../elements/popup/Modal/Context");
const BasicPanelStyle_1 = require("../extra/BasicPanelStyle");
const DefaultPanelHeader_1 = __importDefault(require("../header/DefaultPanelHeader"));
const FiltersTable_1 = __importDefault(require("./FiltersTable"));
function FiltersPanel() {
    const dispatch = (0, DispatchContext_1.useDispatch)();
    const modal = (0, Context_2.useModal)();
    const alert = (0, Context_1.useAlert)();
    function handelDeleteFilter() {
        const buttons = [
            {
                text: 'Yes',
                handler: async () => {
                    const hideLoading = await alert.showLoading('Delete filters process in progress');
                    dispatch({ type: 'DELETE_FILTER', payload: {} });
                    hideLoading();
                },
            },
            { text: 'No' },
        ];
        modal.showConfirmDialog({
            message: 'You are about to delete all processing steps, Are you sure?',
            buttons,
        });
    }
    return ((0, jsx_runtime_1.jsxs)("div", { css: BasicPanelStyle_1.tablePanelStyle, children: [(0, jsx_runtime_1.jsx)(DefaultPanelHeader_1.default, { showSettingButton: false, deleteToolTip: "Delete all filters", onDelete: handelDeleteFilter }), (0, jsx_runtime_1.jsx)("div", { className: "inner-container", children: (0, jsx_runtime_1.jsx)(FiltersTable_1.default, {}) })] }));
}
exports.default = FiltersPanel;
